import '../dropdown';
import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
  <ems-dropdown class="mr-3 mb-3 full-width">
    <button type="button" slot="dropdown-toggle" class="btn btn-outline-light">
      ${until(ctx.currentClassAssignmentSelectionLabel)}
      <span class="ai ai-chevron-down"></span>
    </button>
    <div slot="dropdown-menu" class="dropdown-menu m-0 w-100">
      ${ctx.selections.map((item, itemIndex) => html`
        <button type="button" class="btn dropdown-item" @click="${() => ctx.selectOption(itemIndex)}">${until(item.label)}</button>
      `)}
    </div>
  </ems-dropdown>
`;
